import { MenuItem } from '@infuse/ui/domain';
import { inject, InjectionKey, Ref } from 'vue';

export const UiCurrentMenuInjectionToken: InjectionKey<Ref<MenuItem | undefined>> = Symbol();

export const usePage = () => {
  return inject(UiCurrentMenuInjectionToken);
};
